import axios from "./config";

/**
 * @function
 * @name getProcuringEntities
 * @description get Procuring Entities
 * */
const getProcuringEntities = (filter = {}) =>
  axios
    .get(`/procuring_entities`, { params: filter })
    .then((response) => response.data);

/**
 * detaches a project from list
 *
 * @function
 * @name deleteProcuringEntity
 * @version 0.1.0
 * @since 0.1.0
 */
const deleteProcuringEntity = (procuring_entity) => {
  return axios
    .delete(`procuring_entities/${procuring_entity}`)
    .then((response) => response.data);
};

/**
 * @function
 * @name createProcuringEntity
 * */
const createProcuringEntity = (details) =>
  axios.post(`/procuring_entities`, details).then((response) => response.data);

/**
 * edit existing procuring entity
 *
 * @function
 * @name updateProject
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const updateProcuringEntity = (project, id) => {
  return axios
    .patch(`/procuring_entities/${id}`, project)
    .then((response) => response.data);
};

/**
 * @function
 * @name getPackages
 * @description get getPackage
 * */
const getPackages = (filter = {}) =>
  axios
    .get(`/procuring_entity_packages`, { params: filter })
    .then((response) => response.data);

/**
 * @function
 * @name getPackage
 * @description get getPackage
 * */

// const getPackage = (id) =>
//   axios
//     .get(`/procuring_entity_packages/${id}?report_start_date=2024-01-01&report_end_date=2024-01-31`)
//     .then((response) => response.data);


const getPackage = (id, reportStartDate, reportEndDate) => {
  return axios
    .get(`/procuring_entity_packages/${id}`, {
      params: {
        report_start_date: reportStartDate,
        report_end_date: reportEndDate,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch package", error);
      throw error;
    });
};

/**
 * @function
 * @name getProcuringEntity
 * @description get procuring entity
 * */
const getProcuringEntity = (id) =>
  axios.get(`/procuring_entities/${id}`).then((response) => response.data);

/**
 * @function
 * @name getProcuringEntitiesStatistics
 * @description get procuring entities statistics
 * */
const getProcuringEntitiesStatistics = (id) =>
  axios
    .get(`/procuring_entities/statistics/${id}`)
    .then((response) => response.data);

/**
 * detaches a project from list
 * @function
 * @name deletePackage
 * @version 0.1.0
 * @since 0.1.0
 */
const deletePackage = (package_id) => {
  return axios
    .delete(`procuring_entity_packages/${package_id}`)
    .then((response) => response.data);
};

/**
 * @function
 * @name createPackage
 * */
const createPackage = (details) =>
  axios
    .post(`/procuring_entity_packages`, details)
    .then((response) => response.data);

/**
 * edit existing procuring entity
 *
 * @function
 * @name updatePackage
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const updatePackage = (project, id) => {
  return axios
    .patch(`/procuring_entity_packages/${id}`, project)
    .then((response) => response.data);
};

const getPackageStatistics = (id) => {
  return axios
    .get(`/procuring_entities/${id}/packages/statistics`)
    .then((res) => res.data);
};
const getPackageStatisticsData = (id) => {
  return axios
    .get(`/procuring_entity_packages?filter%5Bprocuring_entity_id%5D=${id}`)
    .then((res) => res.data);
};

/**
 * @function
 * @name downloadESHReport
 * @description download ESH report for a procuring entity
 * @param {number} procuringEntityId - The ID of the procuring entity
 */
const downloadESHReport = (procuringEntityId) => {
  return axios
    .get(`/procuring_entities/${procuringEntityId}/download_esh_report`)
    .then((response) => {
      const { data } = response.data;
      if (data && data.esh_pdf_report) {
        window.open(data.esh_pdf_report, "_blank");
        return response.data;
      } else {
        throw new Error("No ESH report URL found in response");
      }
    })
    .catch((error) => {
      console.error("Error downloading ESH report:", error);
      throw error;
    });
};

export default {
  getProcuringEntities,
  deleteProcuringEntity,
  createProcuringEntity,
  updateProcuringEntity,
  getPackage,
  getPackages,
  deletePackage,
  createPackage,
  updatePackage,
  getProcuringEntitiesStatistics,
  getProcuringEntity,
  getPackageStatistics,
  getPackageStatisticsData,
  downloadESHReport
};
